<template>
    <a class="product-card" v-bind:class="'product-card--' + portfolioType" :href="url">
        <div v-bind:class="[isFinishImageMissing ? `missing-finish` : ``, `product-card__visual-content`]">
            <div class="product-card__missing-finish-cover" v-if="isFinishImageMissing">{{ translations.NoVariantImage }}</div>
            <div class="product-card__img-wrap">
                <div v-if="availabilitySlug !== avblActive" class="corner-badge" v-bind:class="[availabilitySlug ? `corner-badge--${availabilitySlug}` : ``, portfolioType ? `corner-badge--${portfolioType}` : ``]">
                    <span>{{ availability }}</span>
                </div>
                <img v-if="beautyImageUrl" :src="beautyImageUrl + `?$bal%2Dproduct$`" alt="product image" class="product-card__img-beauty" />
                <img v-if="imageUrl" :src="imageUrl + `?$bal%2Dproduct$`" alt="product image" class="product-card__img" />
            </div>
            <span class="product-card__favorite-heart icon-whiteheart" v-bind:class="addedToFavorites ? 'state-favorited' : ''" title="Add to Favorites" @click="addremoveFavorites($event, product)"> <span class="path1"></span><span class="path2"></span> </span>
            <div class="product-card__quickship" v-if="hasQuickship">
                <img src="//images.baldwinhardware.com/is/image/Baldwin/quick-ship-small?scl=1&fmt=png-alpha" class="product-card__quickship-img">
            </div>
        </div>
        <div class="product-card__text-content">
            <div class="product-card__title">{{ title }}</div>
            <div class="product-card__model-number" v-if="modelNumber">Model: {{ modelNumber }}</div>
            <template v-if="!disableComparison">
                <div class="product-card__in-comparison" v-if="inComparisonItemsArray"><span class="icon-compare-selected"></span><span>In Comparison Tray</span></div>
                <div class="product-card__compare" v-bind:class="maxCapacity ? 'disabled' : ''" @click="preventBubble($event)">
                    <input type="checkbox" v-bind:class="maxCapacity ? 'disabled' : ''" :checked="inComparisonItemsArray" :id="`compare-${index}`" :disabled="maxCapacity" @input="addOrRemoveFromArray(product)" />
                    <label :for="`compare-${index}`" v-bind:class="maxCapacity ? 'disabled' : ''" class="m-0 pl-2"> Compare</label>
                </div>
            </template>
        </div>
    </a>
</template>

<script lang="ts">
import { variantGrouping } from 'Vue/interfaces/ProductFilteringInterfaces';
import { useToast } from 'vue-toastification';
const toast = useToast();
import slugify from 'slugify';
import { IProductFilteringTranslations } from 'Vue/interfaces/Interfaces';

export default {
    name: 'ProductCard',
    props: {
        portfolioType: String,
        url: String,
        title: String,
        imageUrl: String,
        beautyImageUrl: String,
        description: String,
        availability: String,
        modelNumber: String,
        index: Number,
        isFinishImageMissing: Boolean,
        hasQuickship: Boolean,
        isDiscontinued: Boolean,
        disableComparison: {
            type: Boolean,
            default: false,
        },
        product: {
            type: Object,
            default: {} as variantGrouping,
        },
        translations: {
            type: Object,
            default: {} as IProductFilteringTranslations,
        },
    },
    data: () => {
        return {
            addedToFavorites: false,
            isSelected: false,
            avblActive: `active`,
        };
    },
    methods: {
        setFavorites: function () {
            let productIds = this.getFavoriteProducts();
            if (this.product.variantSlug != null) {
                if (productIds.indexOf(this.product.variantSlug) > -1) {
                    this.addedToFavorites = true;
                } else {
                    this.addedToFavorites = false;
                }
            }
        },
        addremoveFavorites(event, product) {
            event.preventDefault();
            this.addedToFavorites = !this.addedToFavorites;
            let productIds = this.getFavoriteProducts();
            if (product.variantSlug != null) {
                if (productIds.indexOf(product.variantSlug) < 0) {
                    productIds.push(product.variantSlug);
                } else {
                    productIds.splice(productIds.indexOf(product.variantSlug), 1);
                    // Method to trigger removal of the favorite products when on wishlist page
                    this.$emit('favoriteItemRemoved', product);  
                }
                localStorage.setItem('wishlist-products', JSON.stringify(productIds));
            }
                      
            // This event triggers the Favorites counter in the nav to update             
            window.dispatchEvent(new Event('favorites'));            
        },
        getFavoriteProducts(): string[] {
            let productIds: string[] = [];
            if (localStorage.getItem('wishlist-products')) {
                productIds = JSON.parse(localStorage.getItem('wishlist-products'));
            }
            return productIds;
        },
        addOrRemoveFromArray(product) {
            //product is already in array
            if (this.$store.state?.comparisonItems.filter((p) => p.slug === product.slug).length) {
                let index = this.$store.state?.comparisonItems.indexOf(product);
                this.$store.commit('removeProductFromComparison', index);
                //product is not in the array yet
            } else {
                if (this.$store.state?.comparisonItems?.length <= 4) {
                    this.$store.commit('addProductToComparison', product);
                }
            }
        },
        preventBubble(event) {
            event.stopPropagation();
            if (this.$store.state?.comparisonItems?.length >= 5 && event.target.classList.contains('disabled')) {
                toast.error(`No more than 5 items allowed for comparison`, {
                    timeout: 5000,
                });
            }
        },
    },
    created() {
        this.setFavorites();
    },
    updated() {
        this.setFavorites();
    },
    computed: {
        inComparisonItemsArray: function () {
            return !!this.$store.getters?.comparisonItems?.filter((p) => p.slug === this.product.slug).length;
        },
        maxCapacity: function () {
            return this.$store.getters?.comparisonItems?.length === 5 && this.inComparisonItemsArray === false;
        },
        availabilitySlug: function () {
            return this.availability
                ? slugify(this.availability, {
                      lower: true, // convert to lower case, defaults to `false`
                      strict: true, // strip special characters except replacement, defaults to `false`
                      remove: /[*+~.()'"!:@]/g,
                  })
                : '';
        },
    },
};
</script>

